import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class DynamicContentService {
  private apiUrl = `${API_BASE_URL}/api/dynamic-content`;

  async getContent(filters: { status?: string; sourceId?: number; contentType?: string } = {}) {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.sourceId) params.append('sourceId', filters.sourceId.toString());
    if (filters.contentType) params.append('contentType', filters.contentType);

    const response = await axios.get(`${this.apiUrl}/content?${params.toString()}`);
    return response.data;
  }

  async getSources() {
    const response = await axios.get(`${this.apiUrl}/sources`);
    return response.data;
  }

  async addSource(source: {
    source_name: string;
    source_url: string;
    source_type?: string;
    check_frequency_days?: number;
  }) {
    const response = await axios.post(`${this.apiUrl}/sources`, source);
    return response.data;
  }

  async triggerCheck() {
    const response = await axios.post(`${this.apiUrl}/check`);
    return response.data;
  }

  async updateContentStatus(contentId: number, status: string, reviewerEmail?: string) {
    const response = await axios.put(`${this.apiUrl}/content/${contentId}/status`, {
      status,
      reviewerEmail
    });
    return response.data;
  }

  async editContent(contentId: number, data: {
    description: string;
    editorEmail: string;
    editReason?: string;
  }) {
    const response = await axios.put(`${this.apiUrl}/content/${contentId}/edit`, data);
    return response.data;
  }

  async getBatches() {
    const response = await axios.get(`${this.apiUrl}/batches`);
    return response.data;
  }

  async getStats() {
    const response = await axios.get(`${this.apiUrl}/stats`);
    return response.data;
  }

  async getSchedulerStatus() {
    const response = await axios.get(`${this.apiUrl}/scheduler/status`);
    return response.data;
  }

  async startScheduler() {
    const response = await axios.post(`${this.apiUrl}/scheduler/start`);
    return response.data;
  }

  async stopScheduler() {
    const response = await axios.post(`${this.apiUrl}/scheduler/stop`);
    return response.data;
  }

  async triggerScheduler() {
    const response = await axios.post(`${this.apiUrl}/scheduler/trigger`);
    return response.data;
  }

  async getRelatedExhibitions(exhibitionId: number) {
    const response = await axios.get(`${this.apiUrl}/content/${exhibitionId}/related`);
    return response.data;
  }
}

export const dynamicContentService = new DynamicContentService();